module.exports = __webpack_public_path__ + "img/logoing.0938c67e.jpg";